import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-mist px-5 py-16 sm:py-20" aria-label="Testimonials" data-id="element-331" data-mp="3mfhdhwtirhe1">
      <div className="mx-auto max-w-6xl" data-id="element-332" data-mp="3r93jj656gn0v">
        <SectionHeading kicker="What dental professionals may find valuable" title="A resource designed around real clinical learning needs" data-id="element-333" data-mp="17slxossri0" />
        <p className="mx-auto mt-3 max-w-2xl text-center text-xs italic text-ink/50" data-id="element-334" data-mp="40zw3vzc47gi">
          Illustrative feedback — not verified customer testimonials.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-335" data-mp="dzxs1jz3b39j">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6" data-id="element-336" data-mp="2autusax0ww9i">
              <div className="flex items-center justify-between" data-id="element-337" data-mp="2ftev0ac9zfxy">
                <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-338" data-mp="1sk9dcmcuqoe7">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-339" data-mp="1nt13jp7m110i" data-mpi={i} />)}
                </div>
                <span className="rounded-full bg-mist px-2.5 py-1 text-[11px] font-bold uppercase text-navy-800" data-id="element-340" data-mp="1isdfnceoh0ai">
                  {t.topic}
                </span>
              </div>
              <QuoteIcon className="mt-4 h-7 w-7 text-electric/30" aria-hidden="true" data-id="element-341" data-mp="2bhatn3buwaxg" />
              <blockquote className="mt-2 text-[15px] leading-relaxed text-ink" data-id="element-342" data-mp="26l3lr4zwgpcv">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 border-t border-navy-900/10 pt-5" data-id="element-343" data-mp="22gvxta19ndfp">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-electric" loading="lazy" data-id="element-344" data-mp="1xlqcacbs00s5" />
                <div data-id="element-345" data-mp="m3xlt44jc4rl">
                  <p className="font-display font-extrabold text-navy-950" data-id="element-346" data-mp="m3nu9c3udpjs">{t.name}</p>
                  <p className="text-sm text-ink/60" data-id="element-347" data-mp="nlcnpxu1fsbq">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-12 text-center font-display text-xl font-black uppercase text-navy-950 sm:text-2xl" data-id="element-348" data-mp="sicukaypoz3w">
          Ready to explore the complete system?
        </p>
        <div className="mt-6" data-id="element-349" data-mp="ikyjyrzgz4ji">
          <CtaButton label="Get my 6 volumes + 5 bonuses" data-id="element-350" data-mp="4v4s00so445k" />
        </div>
      </div>
    </section>;
}